export const defaultSettings = {
  darkMode: false,
  compactView: false,
  showEmail: true,
  showPhone2: true,
  pageSize: '50'
};

export const getStoredUserSettings = (userId) => {
  if (userId === undefined || userId === null) {
    return { ...defaultSettings };
  }

  const stored = localStorage.getItem(`userSettings_${userId}`);
  if (!stored) {
    return { ...defaultSettings };
  }

  try {
    return { ...defaultSettings, ...JSON.parse(stored) };
  } catch (error) {
    return { ...defaultSettings };
  }
};

export const saveUserSettings = (userId, settings) => {
  if (userId === undefined || userId === null) return;
  localStorage.setItem(`userSettings_${userId}`, JSON.stringify(settings));
};

export const applyUserTheme = (settings) => {
  const isDarkMode = Boolean(settings?.darkMode);
  document.documentElement.classList.toggle('dark', isDarkMode);
  document.body.classList.toggle('dark', isDarkMode);
};
